import { GetUpdatedRiskRatingCountForPositionsQuery } from "~/graphql/supergraphTypes";

export const calculatePicrPosition = (
  picrPositionData: GetUpdatedRiskRatingCountForPositionsQuery | null | undefined,
): number => {
  if (!picrPositionData || !picrPositionData.picrPositionDetailsByCaseId) return 0;

  return picrPositionData.picrPositionDetailsByCaseId.filter((obj) => {
    const isGroupRow = obj.successorCases && obj.successorCases.length > 0;
    const isNotAttached = !obj.linkedOnboardingCase?.id;

    return !isGroupRow && !isNotAttached;
  }).length;
};
